$(document).ready(function()
{
    if ($('.video-bg-youtube').length)
    {
   
        $(".video-bg-youtube").each(function()
        {
            var video_id = $(this).data("video-id");
            var spinner = $(this).find('.spinner');

            if (video_id && video_id.length > 3)
            {
                if (spinner)
                {
                    $(this).css('background-image', 'none');
                    spinner.addClass('active');
                    //console.log("spinning");
                }
                $(this).YTPlayer(
                {
                    // URL of the YouTube video
                    videoURL: video_id,
                    containment:'self',
                    autoPlay:true, 
                    playOnlyIfVisible:true, 
                    loop:5, 
                    mute:true, 
                    startAt:0, 
                    opacity:1,
                    controls:1,
                    showYTLogo:false,
                    useNoCookie:true,
                    onReady: function(event) {   
                        if (spinner)
                        {
                            spinner.removeClass('active');
                            //console.log("not spinning");
                        }
                    }
                });
            }
        });

    } 

});

$(document).ready(function()
{
    if ($('.video-bg-vimeo').length)
    {
   
        $(".video-bg-vimeo").each(function()
        {
            var video_id = $(this).data("video-id");
            var spinner = $(this).find('.spinner');

            if (video_id && video_id.length > 3)
            {
                if (spinner)
                {
                    $(this).css('background-image', 'none');
                    spinner.addClass('active');
                    //console.log("spinning");
                }
                $(this).vimeo_player(
                {
                    // URL of the Vimeo video
                    videoURL: video_id,
                    containment:'self',
                    autoPlay:true, 
                    stopMovieOnBlur:true, 
                    optimizeDisplay:true,
                    loop:5, 
                    mute:true, 
                    startAt:0, 
                    opacity:1,
                    showControls:true,
                    useNoCookie:true,
                    show_vimeo_logo:false,
                });

                $(this).on("VPReady", function(event) 
                {   
                    if (spinner)
                    {
                        spinner.removeClass('active');
                        //console.log("not spinning");
                    }
                });

            }
        });

    } 
});

